import * as React from "react";
import { useContext } from "react";
import { toast } from "react-toastify";
import { ProjectState } from "../../../../ViewModel/ProjectState";
import { LeftSideLeftGapSpan } from "../../Cards/Card";
import DeleteIcon from "./DeleteIcon";
import { EditProjectContext } from "../../../EditProjectContext";
import { RouteEditTab } from "../../../RouteEditTab";
import { isFinished } from "../IsFinished";
import RemoveSpdrCommand from "./RemoveSpdrCommand";
import SaveProject from "../../../SaveProject";
import { confirm } from "../../../../../Layout/Dialog/ConfirmDialog";
import { SpdrCardProps } from "../SpdrCard";
import { SpdrPdsrDeleteProps } from "../../Cards/CardDeletionProps";

type Props = {
  disabled: boolean;
};

export default function SpdrDelete({
  spdr,
  noDeletionProcessCurrentlyRunning,
  setNoDeletionProcessCurrentlyRunning,
  disabled,
}: SpdrCardProps & SpdrPdsrDeleteProps & Props) {
  const { project, routeEditTabSelected, reloadData } = useContext(EditProjectContext);

  const spdrId = spdr?.SpdrId || 0;
  const $hasDeleteButton = routeEditTabSelected === RouteEditTab.Ftl && !disabled;
  const $isFinished = isFinished(project, spdrId);

  const onDeleteClick = async () => {
    const isConfirmed = await confirm(
      "Do you want to remove the SPDR from current project with all connected routes and spdrs?"
    );
    if (!isConfirmed) {
      return;
    }
    setNoDeletionProcessCurrentlyRunning(false);
    await SaveProject({ project });
    await toast.promise(RemoveSpdrCommand(project.ProjectId || -1, spdrId), {
      pending: "Deleting spdr",
      success: "Spdr was successfully deleted",
      error: "Error occurred while deleting Spdr",
    });
    await reloadData();
    setNoDeletionProcessCurrentlyRunning(true);
  };

  if (project.State !== ProjectState.Sandbox) {
    return <span />;
  }

  return (
    <LeftSideLeftGapSpan style={{ visibility: $hasDeleteButton ? "visible" : "hidden" }}>
      <DeleteIcon
        $isFinished={$isFinished}
        deletionAllowed={noDeletionProcessCurrentlyRunning}
        onClick={() => noDeletionProcessCurrentlyRunning && onDeleteClick()}
      />
    </LeftSideLeftGapSpan>
  );
}
